import {ReportGroupingLevel} from '../../constants'
import {LeaveTypeBalanceQualifier, LeaveTypeColumnConfig} from '../../leavesReport/LeaveReportConfig'
import $ from 'jquery'
import LeavesReportEditConfigController from './LeavesReportEditConfigController'

export default class LeavesEditFormConfigController extends LeavesReportEditConfigController {}

LeavesEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function ( reportParameters ) {
    const result = $.extend({}, reportParameters);

    const isEnabledPTO = this.productSettingsValidator.isPTOEnabled();
    const isEnabledSick = this.productSettingsValidator.isSickEnabled();

    if (!isEnabledPTO && reportParameters.balanceQualifier !== LeaveTypeBalanceQualifier.SICK_DAYS_ONLY) {
        result.balanceQualifier = LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;
    }
    if (!isEnabledSick && reportParameters.balanceQualifier !== LeaveTypeBalanceQualifier.PTO_ONLY) {
        result.balanceQualifier = LeaveTypeBalanceQualifier.PTO_ONLY;
    }

    if ((!isEnabledPTO && !isEnabledSick) || !result.balanceQualifier) {
        result.columnsConfig = LeaveTypeColumnConfig.LEAVE_TIME_ONLY;
    }
    if (!this.productSettingsValidator.isUGREnabled())
    {
        const groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.USER_GROUP,
            [result.firstGroupingLevel, result.secondGroupingLevel],
            ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    return result;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/leaves/LeavesEditFormConfigController.js